export const location = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        location:'location',
        description:'Description',
        edit_location:'Edit location',
        location_information:'Location Information',
        location_description:'Location Description',
        zone_name:'Zone Name',
        email_id:'Email ID',
        phone_number:'Phone Number',
        address:'Address',
        address_line1:'Address Line1',
        address_line2:'Address Line2',
        state:'State',
        select_state:'Select State',
        select_zone:'Select Zone',
        city:'City',
        select_city:'Select City',
        pincode:'Pincode',
        upload_logo:'Location Logo',
        is_active:'Is active',
        is_inactive:'Is Inactive',
        cancel:'cancel',
        location_management:'Location Management',
        add_location:'Add location',
        location_id:'location ID',
        location_name:'location Name',
        phone:'Phone',
        zone:'Zone',
        action:'Action',
        activate:'Activate',
        group_email_id:'Group EmailId',
        mobile: 'Mobile',
        submit:'submit',
        customer_id:'Customer ID',
        select_customer:'Select Customer',
        location_status:'Location Status',
        mobile_number:'Mobile Number',
        image_format:'Only allowed jpg, jpeg, png',
        image_size:'Size Maximum 2MB',
        location_admin_user_config: "Location Admin User Configuration",
    },
    ar: {
        location:'الموثع',
        description:'وصف',
        edit_location:'تحديد الوجهة',
        location_information:'معلومات الموقع',
        location_description:'وصف الموقع',
        zone_name:'اسم المنطقة',
        email_id:'عنوان الايميل',
        phone_number:'رقم الهاتف',
        address:'عنوان',
        address_line1:'العنوان السطر 1',
        address_line2:'سطر العنوان 2',
        state:'حالة',
        select_state:'اختر ولايه',
        select_zone:'حدد المنطقة',
        city:'مدينة',
        select_city:'اختر مدينة',
        pincode:'الرمز السري',
        upload_logo:'شعار الموقع',
        is_active:'نشط',
        is_inactive:'غير نشط',
        cancel:'إلغاء',
        location_management:'إدارة الموقع',
        add_location:'أضف الموقع',
        location_id:'معرف الموقع',
        location_name:'اسم الموقع',
        phone:'هاتف',
        zone:'منطقة',
        action:'عمل',
        activate:'تفعيل',
        group_email_id:'معرف البريد الإلكتروني للمجموعة',
        mobile: 'التليفون المحمول',
        submit:'إرسال',
        customer_id:'هوية العميل',
        select_customer:'حدد العميل',
        location_status:'حالة الموقع',
        mobile_number:'رقم الهاتف المحمول',
        image_format:'مسموح فقط بتنسيق jpg jpeg png',
        image_size:'الحجم الأقصى 2 ميغا بايت',
        location_admin_user_config: "تعديل صلاحيات المسؤوليين",
    }
}